import ScoreBars, { ScoreStrength } from "@/components/controls/ScoreBars";
import { DataTableFilter } from "@/components/controls/DataTableFilters/DataTableFilters";
import { IcpFit } from "@/entities/icpFit/types";
import { icpFitToScoreBarsMap } from "@/entities/icpFit/helpers";

// Page-level filter definition for an ICP fit column. ICP fit is a fixed,
// code-defined enum (like status / referenceability), so it uses the client
// `enum` filter — the enum values are translated via icpFit.values.* and each
// option shows its score bars. Every value is offered, UNKNOWN included: a user
// looking for the records Dreamer could not assess has no other way to find
// them. Never-scored entities hold NULL, a separate state from UNKNOWN, and
// stay reachable through the no-value option.
export const getIcpFitFilterOption = (columnKey: string): DataTableFilter => ({
  key: columnKey,
  filterType: {
    type: "enum",
    values: {
      enumType: IcpFit,
      entityType: "icpFit",
      valueType: "values",
      getIcon: (value: IcpFit) => (
        <ScoreBars score={icpFitToScoreBarsMap[value] as ScoreStrength} />
      )
    }
  }
});
